import { useTranslation } from "react-i18next";
import ScrollReveal from "@/components/ScrollReveal";
import HotelVsGuestlyComparison from "@/components/calculator/HotelVsGuestlyComparison";
import SavingsCalculator from "@/components/calculator/SavingsCalculator";
import CalculatorCTA from "@/components/calculator/CalculatorCTA";
import SEO from "@/components/SEO";
import ArticleSchema from "@/components/ArticleSchema";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const CorporateCalculator = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO page="calculator" />
      <ArticleSchema 
        headline={t("corporateCalculator.intro.headline")}
        description={`${t("corporateCalculator.intro.subheadline")} ${t("corporateCalculator.intro.paragraph")}`}
        datePublished="2024-11-01T00:00:00Z"
        dateModified="2024-11-19T00:00:00Z"
        articleSection="Corporate Housing Cost Calculator"
        keywords={[
          "corporate housing calculator",
          "hotel cost comparison", 
          "extended stay savings",
          "business travel calculator",
          "accommodation cost calculator",
          "furnished apartment pricing",
          "corporate housing vs hotels"
        ]}
      />
      <main className="min-h-screen bg-background">
        {/* Header with Logo and Back Button */}
        <header className="w-full py-6 px-6 border-b border-border bg-background/95 backdrop-blur-sm sticky top-0 z-50">
          <div className="container mx-auto flex items-center justify-between">
            <Logo width={120} height={40} />
            <a href="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Home
              </Button>
            </a>
          </div>
        </header>


        {/* Intro Section */}
        <section className="w-full py-20 bg-gradient-to-b from-background to-muted/30">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center space-y-6">
              <ScrollReveal>
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
                  {t("corporateCalculator.intro.headline")}
                </h1>
              </ScrollReveal>

              <ScrollReveal delay={0.1}>
                <p className="text-xl md:text-2xl text-muted-foreground font-medium">
                  {t("corporateCalculator.intro.subheadline")}
                </p>
              </ScrollReveal>

              <ScrollReveal delay={0.2}>
                <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                  {t("corporateCalculator.intro.paragraph")}
                </p>
              </ScrollReveal>
            </div>
          </div>
        </section>

        {/* Comparison Section */}
        <HotelVsGuestlyComparison />

        {/* Calculator Section */}
        <SavingsCalculator />

        {/* CTA Section */}
        <section className="w-full py-16 bg-muted/30">
          <div className="container mx-auto px-6">
            <div className="max-w-2xl mx-auto">
              <CalculatorCTA />
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default CorporateCalculator;
